import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Dashboard = () => {
    //employees holds the list of employees, initially it's an empty array
    const [employees, setEmployees] = useState([]);
    //departments holds department names with their Ids as keys
    const [departments, setDepartments] = useState({}); //set as an emoty object
    const [searchTerm, setSearchTerm] = useState(""); //search term for searching employees
    // setting the initial page number to 1
    const [currentPage, setCurrentPage] = useState(1);
    const employeesPerPage = 5; //show 5 employees per page

    const navigate = useNavigate();

    useEffect(() => {
        //fetch data is an async function to get Employee and department data
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("token");

                const empRes = await axios.get("https://jerinmjohn.pythonanywhere.com/api/employees/", {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                });

                const deptRes = await axios.get("https://jerinmjohn.pythonanywhere.com/api/departments/", {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                });


                const deptMap = {};
                deptRes.data.forEach(dept => {
                    deptMap[dept.DepartmentId] = dept.DepartmentName;
                });

                setEmployees(empRes.data);
                setDepartments(deptMap);

            } catch (error) {
                alert("Error fetching data");
                console.log(error);
            }
        };

        fetchData();
    }, []);

    // logout function

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/"); // Redirect to login page
    };

    // handle search input change
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

    // filter employees based on search term
    const filteredEmployees = employees.filter((emp) => {
        const deptName = departments[emp.DepartmentID] || "unknown";
        return (
            emp.EmployeeName.toLowerCase().includes(searchTerm) ||
            emp.Designation.toLowerCase().includes(searchTerm) ||
            deptName.toLowerCase().includes(searchTerm)
        );
    });
    // currentpage-The page number we are on right now
    // employeesPerPage-How many employees we want to show on each page
    // this calculates the last position of the employee to show current page
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
    const currentEmployees = filteredEmployees.slice(indexOfFirstEmployee, indexOfLastEmployee);
    const totalPages = Math.ceil(filteredEmployees.length / employeesPerPage);
    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="text-center m-0">Dashboard</h2>
                <button className="btn btn-danger" onClick={handleLogout}>
                    Logout
                </button>

            </div >
            {/* Add Employee button */}
            <div className="mb-3 text-end">
                <Link to="/addemployee" className="btn btn-success">
                    Add Employee</Link>
            </div>

            {/* Search Input */}
            <div className="mb-3">
                <input
                    type="text"
                    placeholder="Search by Name, Designation or Department"
                    className="form-control"
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
            </div>

            {/* Employee list */}

            <div className="card p-3 mb-4">
                <h3>Employees</h3>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Department</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentEmployees.map((emp) => (
                            <tr key={emp.EmployeeId}>
                                <td>{emp.EmployeeName}</td>
                                <td>{emp.Designation}</td>
                                <td>{departments[emp.DepartmentID] || "unknown"}</td>
                                <td>
                                    {/* <button className="btn btn-primary btn-sm me-2">Edit</button> */}
                                    <Link to={`/edit-employee/${emp.EmployeeId}`} className="btn btn-primary btn-sm me-2">
                                        Edit
                                    </Link>
                                    {/* <button className="btn btn-primary btn-sm me-2">Delete</button> */}
                                    <Link to={`/delete-employee/${emp.EmployeeId}`} className="btn btn-danger btn-sm">
                                        Delete
                                    </Link>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Pagination  Buttons*/}
                <div className="d-flex justify-content-center mt-3">
                    <button className="btn btn-secondary me-2"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}>
                        Previous

                    </button>
                    <span className="align-self-center">
                        Page {currentPage} of {totalPages}

                    </span>
                    <button className="btn btn-secondary ms-2"
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
                <div className="mb-3 text-end">
                    <Link to="/add-department" className="btn btn-success">
                        Add Department</Link>
                </div>
                <div className="card p-3">
                    <h3>Departments</h3>
                    <ul className="list-group">
                        {Object.values(departments).map((deptName, index) => (
                            <li key={index} className="list-group-item">{deptName}</li>
                        ))}
                    </ul>

                </div>
            </div>


            );




};
            export default Dashboard;

